module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28965",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9623",
      "ably-hubspot-js": "static-2.4665",
      "atom": "static-1.5020",
      "conversations-async-data": "static-2.7613",
      "conversations-error-reporting": "static-1.8831",
      "conversations-internal-pub-sub": "static-1.15922",
      "conversations-internal-schema": "static-1.12789",
      "conversations-message-history": "static-1.12511",
      "conversations-test-sdk": "static-1.10451",
      "conversations-visitor-experience-components": "static-1.22328",
      "head-dlb": "static-1.4938",
      "hs-promise-utils": "static-1.5542",
      "hs-test-utils": "static-1.7964",
      "hubspot-dlb": "static-2.1832",
      "HubStyleTokens": "static-2.11409",
      "I18n": "static-7.1610",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2967",
      "jasmine-runner": "static-1.6418",
      "quartz": "static-1.6952",
      "react-dlb": "static-1.77",
      "react-select-plus": "static-1.104",
      "react-transition-group": "static-2.64",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4421",
      "StyleGuideUI": "static-3.486",
      "transmute": "static-2.85",
      "urlinator": "static-1.4480",
      "usage-tracker": "static-1.7287",
      "usage-tracker-core": "static-1.7137",
      "usage-tracker-public": "static-1.7098",
      "viral-links-lib": "static-1.7001",
      "visitor-ui-component-library": "static-1.6087",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4757",
      "conversations-prop-types": "static-1.7400",
      "conversations-visitor-message-history": "static-1.21065",
      "cssUtils": "static-1.778",
      "enviro": "static-4.428",
      "flux-actions": "static-1.330",
      "foundations-components": "static-1.7826",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6169",
      "hubspot-url-utils": "static-1.4049",
      "immutable": "static-2.77",
      "metrics-js": "static-1.9542",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.388",
      "raven": "static-3.5829",
      "react": "static-7.184",
      "react-aria": "static-1.65",
      "react-dom": "static-7.85",
      "react-redux": "static-7.70",
      "react-rhumb": "static-1-feature-id-1324-marker-timings.12",
      "react-utils": "static-2.5300",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8092",
      "signup-constants": "static-1.18740",
      "styled-components": "static-2.88",
      "usage-tracker-multi": "static-1.5701",
      "visitor-ui-component-library-icons": "static-1.5898",
      "hs-promise-rejection-tracking": "static-1.5489",
      "raven-hubspot": "static-1.6136",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3359",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.85",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.81",
      "quartz-config": "static-1.730",
      "quartz-core": "static-1.6171",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4805",
      "foundations-theming": "static-1.4365",
      "UIComponents": "static-3.8356",
      "customer-data-email": "static-1.17937",
      "cv-backend-services": "static-1.1551",
      "immutable-less": "static-1.4598",
      "conversations-skeleton-state": "static-1.7197",
      "crm-events-viz-core": "static-1.33010",
      "customer-data-objects": "static-1.7610",
      "icons": "static-2.643",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4598",
      "ui-images": "static-2.1138",
      "HeadJS": "static-2.740",
      "framer-motion": "static-1.71",
      "hs-test-utils-bend-plugin": "static-1.3075",
      "msw": "static-1.39",
      "testing-library": "static-1.151",
      "i18n-data": "static-1.220",
      "moment-timezone": "static-5.82",
      "jasmine": "static-4.4273",
      "signup-ui-url-generator": "static-2.7987",
      "HubStyle": "static-2.11717",
      "quartz-i18n": "static-1.627",
      "sassPrefix": "static-1.155",
      "bend-plugin-foundations-components": "static-1.4095",
      "floating-ui": "static-1.55",
      "foundations-theming-specialty": "static-1.2081",
      "hs-story-utils": "static-1.9377",
      "react-create-root-preference": "static-1.9",
      "react-virtualized": "static-2.98",
      "tanstack-table": "static-1.54",
      "trellis-assets": "static-1.1656",
      "ui-fonts": "static-1.671",
      "hs-locale-management": "static-1.40",
      "csstype": "static-1.50",
      "quartz-head": "static-1.617",
      "quick-fetch": "static-1.3873",
      "web-vitals": "static-1.4",
      "quartz-routing": "static-1.382",
      "usage-tracker-anonymous": "static-1.5704",
      "bender-build-tools": "static-1.3123",
      "dispatcher": "static-1.135",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.826",
      "hubspotter-http": "static-1.4608",
      "mobile-manifest-mixins": "static-1.514",
      "module-federation": "static-1.22",
      "quartz-auth": "static-1.627",
      "quartz-test": "static-1.627",
      "quartz-tracking": "static-1.331",
      "usage-tracker-container": "static-1.7277",
      "bend-plugin-foundations-theming": "static-1.2848",
      "foundations-theming-base": "static-1.3350",
      "stylex": "static-1.32",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4597",
      "customer-data-ui-utilities": "static-1.9775",
      "FileManagerCore": "static-1.38958",
      "FileManagerLib": "static-1.39099",
      "hubspot-apollo-client": "static-1.4825",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.524",
      "timezone-utils": "static-2.5192",
      "ui-gdpr-components": "static-1.10296",
      "ts-schema": "static-1.4034",
      "ai-components-ui-library": "static-1.8793",
      "avatar-components": "static-1.2446",
      "content-assistance-lib": "static-1.7669",
      "crm-component-utils": "static-1.38929",
      "crm-display-components": "static-1.24679",
      "crm-fe-perf": "static-1.22852",
      "crm-links": "static-1.6230",
      "crm-message-bus": "static-1.42835",
      "crm-search-service-types": "static-1.1101",
      "crm-source-interpretation-lib": "static-1.5286",
      "customer-data-communicator": "static-1.45372",
      "customer-data-filters-ui": "static-1.39558",
      "customer-data-objects-ui-components": "static-1.12973",
      "customer-data-properties": "static-1.51354",
      "customer-data-rte": "static-1.32848",
      "draft-plugins": "static-2.21574",
      "file-manager-components": "static-1.23459",
      "framework-data-schema-resolvers": "static-1.6827",
      "frontend-preferences-client": "static-1.7876",
      "hubspot-prosemirror": "static-1.18077",
      "object-comments-thread-lib": "static-1.10502",
      "prosemirror-user-and-team-at-mentions": "static-1.473",
      "reference-resolvers-lite": "static-1.8043",
      "ui-addon-upgrades": "static-9.17910",
      "universal-associations-select": "static-1.10971",
      "universal-record-utils-lib": "static-1.716",
      "wootric-nps": "static-1.6932",
      "inbound-db-properties-service-client": "static-1.3797",
      "property-translator": "static-1.5351",
      "bend-plugin-chirp-manifest": "static-1.8",
      "chirp-fetch": "static-1.1834",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "hub-http-shared-msw-handlers": "static-1.9836",
      "hubspotter-http-shared-msw-handlers": "static-1.9834",
      "usage-tracker-session-replay": "static-1.4973",
      "react-dnd-compat": "static-1.4568",
      "audio-components": "static-1.5834",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29197",
      "FileManagerImages": "static-1.36610",
      "foundations-components-legacy": "static-1.851",
      "immerable": "static-1.4102",
      "ui-universal-auth": "static-1.8910",
      "video-components": "static-1.13092",
      "video-data-lib": "static-1.34747",
      "video-embed": "static-1.35581",
      "hubspot-apollo-cache": "static-1.284",
      "chatspot-core": "static-1.21022",
      "ContentUtils": "static-1.68199",
      "copilot-toolkit": "static-1.10969",
      "superstore": "static-1.4715",
      "ui-addon-video-player": "static-1.8647",
      "ui-coaching-tips": "static-1.28389",
      "card-properties-lib": "static-1.44007",
      "commerce-subscription-lib": "static-1.36939",
      "crm-actions": "static-1.6267",
      "crm-cards-sdk": "static-1.43415",
      "customer-data-properties-shared-msw-handlers": "static-1.9163",
      "customer-data-property-utils": "static-1.8032",
      "customer-data-tracking": "static-1.6834",
      "hs-resources": "static-1.93",
      "inbound-db-meta-service-client": "static-1.3547",
      "pulse": "static-1.504",
      "framework-data-table": "static-2.11792",
      "location-customization-utils-lib": "static-1.9078",
      "calling-error-reporting": "static-1.31255",
      "calling-internal-common": "static-1.31249",
      "calling-usage-tracker": "static-1.6490",
      "crm_data": "static-4.91777",
      "customer-data-content": "static-1.27174",
      "draft-content-plugins": "static-1.28116",
      "draft-convert": "static-2.72",
      "draft-extend": "static-3.74",
      "draft-js": "static-5.77",
      "draft-signature-plugin": "static-1.23919",
      "EmailSignatureEditor": "static-1.24254",
      "hubspot-prosemirror-plugins": "static-1.18069",
      "integration-settings-components": "static-1.15309",
      "integrations-lib": "static-1.15941",
      "integrations-tracking-lib": "static-1.5547",
      "native-integrations-shared-strings": "static-1.7732",
      "nav-meta": "static-1.29475",
      "onboarding-scopes": "static-1.6411",
      "outreach-assistant-email-generation": "static-1.6102",
      "prosemirror-copilot": "static-1.11460",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37881",
      "react-colorpicker": "static-2.10159",
      "reference-resolvers": "static-1.8118",
      "rich-text-lib": "static-1.19735",
      "sales-email-signature-service-client": "static-1.3792",
      "sequences-lib": "static-1.7945",
      "ui-addon-i18n": "static-1.11099",
      "ui-addon-iframeable": "static-1.9001",
      "ui-business-units-lib": "static-1.8996",
      "ui-shepherd-react": "static-3.10097",
      "user-context": "static-1.5050",
      "whatsapp-sending-lib": "static-1.5476",
      "customer-data-filters-ui-msw-helpers": "static-1.21993",
      "customer-data-reference-ui-components": "static-1.13107",
      "FormUrlGenerator": "static-2.4668",
      "framework-builder-read-service-client": "static-1.3966",
      "framework-data-schema-quick-fetch": "static-1.6732",
      "multi-account-reference-resolvers": "static-1.928",
      "onboarding-tours": "static-1.16495",
      "reporting-datasets-permissions-lib": "static-1.13507",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21476",
      "calling-global-api": "static-1.64315",
      "calling-lifecycle-internal": "static-1.65697",
      "calling-lifecycle-messages": "static-1.57991",
      "commerce-products-lib": "static-1.9321",
      "conditional-properties-service-client": "static-1.3753",
      "external-options-client-types": "static-1.4115",
      "google-libphonenumber": "static-1.37",
      "inbounddb-objects-service-types": "static-1.4180",
      "meetings-icalendar-utils-lib": "static-1.579",
      "multi-currency-client-types": "static-1.3648",
      "object-builder-ui-client": "static-1.48550",
      "pipeline-validation-client-types": "static-1.3922",
      "property-value-citations": "static-1.1968",
      "smart-property-lib": "static-1.6665",
      "tiered-pricing": "static-1.1094",
      "ui-addon-form-validation": "static-1.10937",
      "video-components-external": "static-1.11089",
      "batch-promise": "static-1.1499",
      "crm-pipelines-api-client-types": "static-1.4099",
      "persist-promise": "static-1.3656",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25204",
      "knowledge-content-types": "static-1.8479",
      "payment-link-components": "static-1.23374",
      "ui-addon-emoji-picker": "static-1.9836",
      "call-summary": "static-1.39005",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9982",
      "laboratory-lib": "static-3.7107",
      "merchandise-lib": "static-1.262",
      "purchase-motions-components": "static-1.5786",
      "crm-object-search-query-utilities": "static-1.9450",
      "amplitude-session-replay-browser": "static-1.59",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.705",
      "content-icons-ui": "static-1.2211",
      "social-insights-client-types": "static-1.21929",
      "outpost": "static-1.4138",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4759",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5526",
      "magpie-types": "static-1.4986",
      "simple-logging-lib": "static-1.2997",
      "growth-onboarding-feedback-components": "static-1.6532",
      "customer-data-sidebar": "static-2.45842",
      "enrichment-properties-lib": "static-1.15783",
      "commerce-billing-lib": "static-1.18904",
      "commerce-shared-components-lib": "static-1.18364",
      "commerce-tools-ui-lib": "static-1.10224",
      "bend-plugin-pulse": "static-1.7",
      "directed-graph": "static-1.884",
      "event-emitter": "static-1.897",
      "fast-json-patch": "static-1.62",
      "customer-data-associations": "static-1.7274",
      "deal-intel-decorators": "static-1.1816",
      "reporting-data": "static-1.67282",
      "tanstack-virtual": "static-1.29",
      "ui-addon-draggable": "static-3.4718",
      "crm-record-cards-service-types": "static-1.3567",
      "self-service-api": "static-1.10194",
      "crm_universal": "static-1.21911",
      "SalesContentIndexUI": "static-3.9162",
      "content-embed-lib": "static-1.7288",
      "data-model-builder-lib": "static-1.12152",
      "remote-ui": "static-1.64",
      "ui-components-test-utils": "static-1.5547",
      "ui-extensions-remote-renderer": "static-1.16856",
      "universal-page-editor-lib": "static-1.2961",
      "integrations-error-boundary-lib": "static-1.13356",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10320",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.424",
      "messaging-types-lib": "static-1.45836",
      "ai-addon-copilot-preview": "static-1.8005",
      "copilot-plugins": "static-1.10942",
      "data-token-picker": "static-1.16308",
      "sequences-client-types-lib": "static-1.7802",
      "foundations-components-test-utils": "static-1.5309",
      "navigation-messaging": "static-1.7165",
      "getting-started-shared-tasks": "static-1.18340",
      "getting-started-shared-tasks-store": "static-1.17458",
      "onboarding-tours-utils": "static-1.561",
      "messaging-usage-based-billing-components-lib": "static-1.961",
      "whatsapp-management-lib": "static-1.8635",
      "growth-data-modal": "static-1.5342",
      "growth-onboarding-confetti": "static-1.3016",
      "growth-onboarding-next-action-utils": "static-1.1752",
      "navigation-components": "static-1.17838",
      "onboarding-tours-client": "static-1.4709",
      "ui-shepherd-tracker": "static-1.7478",
      "shared-worker-versioning": "static-1.10986",
      "voice-sms-access-library": "static-1.758",
      "commerce-permissions": "static-1.714",
      "products-iframe-lib": "static-1.7766",
      "products-ui-components-shared-msw-handlers": "static-1.10218",
      "data-agent-kit": "static-1.108",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9919",
      "fsm": "static-1.3681",
      "policy-lib": "static-1.6721",
      "react-tinymce": "static-1.55084",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54210",
      "tinymce-plugins": "static-1.57324",
      "tinymce-themes": "static-1.56180",
      "content-media-composition-data-lib": "static-1.12063",
      "content-media-compositions": "static-2.16070",
      "idb-keyval": "static-1.43",
      "media-bridge-lib": "static-1.18831",
      "ui-addon-opt": "static-4.8322",
      "commerce-tours-lib": "static-1.5993",
      "growth-onboarding-reliability": "static-1.5030",
      "sales-checkout-service-client": "static-1.3588",
      "calling-cross-tab-library": "static-1.19226",
      "calling-lifecycle-usage-tracker": "static-1.8549",
      "purchase-motions-api": "static-1.5789",
      "trials-service-types": "static-1.3852",
      "reactive-lib": "static-1.670",
      "card-payment-highlight-lib": "static-1.37006",
      "card-subscription-highlight-lib": "static-1.39362",
      "commerce-contract-lib": "static-1.11833",
      "invoices-highlight-card-lib": "static-1.54526",
      "orders-highlight-card-lib": "static-1.21304",
      "products-highlight-card-lib": "static-1.17605",
      "quotes-highlight-card-lib": "static-1.71791",
      "usage-based-billing-components-lib": "static-1.8606",
      "utility-belt": "static-1.2486",
      "payments-enrollment-embed-lib": "static-1.22515",
      "stripe-embedded-components": "static-1.7405",
      "growth-onboarding-empty-states": "static-1.5615",
      "InboxConnectUtils": "static-4.14645",
      "payments-post-enroll-local-storage-lib": "static-1.5058",
      "qrcode-generator": "static-1.68",
      "deal-intel-utils": "static-1.1820",
      "storybook-react": "static-1.32",
      "reporting-client-types": "static-1.2463",
      "react-flip-move": "static-1.69",
      "FireAlarmUi": "static-1.4470",
      "sales-templates-service-types-lib": "static-1.4124",
      "ui-asset-management-lib": "static-1.10952",
      "association-settings-lib": "static-1.10125",
      "collaboration-sidebar": "static-1.57628",
      "conditional-property-settings-modal": "static-1.12336",
      "data-model-commons-lib": "static-1.12415",
      "final-form": "static-1.69",
      "html-to-image": "static-1.53",
      "nudge-client-utils": "static-1.2439",
      "object-definition-builder-lib": "static-1.7036",
      "property-management-iframe": "static-1.12974",
      "property-usages-lib": "static-1.5372",
      "reactflow": "static-1.63",
      "simple-data-table": "static-1.2616",
      "used-in-list-lib": "static-1.6891",
      "visual-association": "static-1.5819",
      "highcharts": "static-8.103",
      "reporting-visualizations": "static-1.59358",
      "ui-extensibility-client-types": "static-1.3878",
      "google-sheets-integration-lib": "static-1.73",
      "microsoft-drive-integration-lib": "static-1.185",
      "automation-platform-service-types": "static-1.2565",
      "ContentData": "static-1.68274",
      "email-portal-health-service-types": "static-1.925",
      "marketing-email-service-types": "static-1.1883",
      "ai-rendering-library": "static-1.9897",
      "ai-settings-ui-library": "static-1.7798",
      "ui-brand-identity-lib": "static-1.14990",
      "messaging-shared-utils-lib": "static-1.410",
      "messaging-user-info-utils-lib": "static-1.580",
      "content-whatsapp-service-types": "static-1.352",
      "marketing-platform-lib": "static-1.6800",
      "short-messages-app-service-client": "static-1.3930",
      "ui-tool-access": "static-1.10098",
      "onboarding-data-sync-lib": "static-1.1871",
      "growth-onboarding-next-action-components": "static-1.1780",
      "user-context-client": "static-1.4558",
      "nest": "static-1.174",
      "calling-orchestration-schema": "static-1.35535",
      "sales-views-client-types": "static-1.4213",
      "trellis-story-utils": "static-1.4464",
      "hub-http-contrib": "static-1.2989",
      "interframe": "static-3.4710",
      "tinymce-data": "static-1.40295",
      "ui-addon-sales-email": "static-1.5159",
      "codemirror": "static-5.94",
      "layout-dnd-components": "static-1.12337",
      "layout-dnd-utils": "static-1.11312",
      "react-codemirror": "static-1.10572",
      "NamespacedHubStyle": "static-2.9019",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.39840",
      "quotes-ui-lib": "static-1.80512",
      "zustand": "static-1.72",
      "accounting-integrations-ui-components": "static-1.6973",
      "invoices-ui-lib": "static-1.54542",
      "commerce-products-api": "static-1.2207",
      "invoices-iframe-lib": "static-1.56600",
      "quotes-modal-lib": "static-1.102469",
      "platform-infra-nav-components": "static-1.7628",
      "reporting-ui-components": "static-2.64553",
      "subscription-experience-data-types": "static-1.14836",
      "marketplace-ui-apps-core": "static-1.18038",
      "stripe-connect-js": "static-1.67",
      "ui-addon-react-router-dom": "static-1.9494",
      "nested-table": "static-1.174",
      "chatspot-widget-iframe": "static-1.21013",
      "collaboration-sidebar-common": "static-1.2425",
      "crm-properties-common-lib": "static-1.5825",
      "ui-addon-draggable-compat": "static-2.4203",
      "nudge-custom-function-registry": "static-1.2196",
      "nudge-renderer-utils": "static-1.2515",
      "whisper-core-api": "static-1.6447",
      "property-management-common": "static-1.5262",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15042",
      "advanced-menus-lib": "static-1.11996",
      "ExportDialog": "static-6.10342",
      "ui-memberships-settings-lib": "static-1.33893",
      "embedded-academy-lib": "static-1.14144",
      "highlight.js": "static-1.78",
      "reporting-action-components": "static-1.41149",
      "reporting-snowflake": "static-1.55900",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9637",
      "browser-eslint": "static-2.57",
      "commerce-tax-lib": "static-1.471",
      "property-description-translator": "static-1.3796",
      "commerce-analytics-service-client": "static-1.3576",
      "totals-ui-components": "static-1.23425",
      "reporting-plugins": "static-1.10202",
      "reporting-reports": "static-1.66960",
      "edison-service-client-types": "static-1.335",
      "developer-experience-shared-components": "static-1.10457",
      "marketplace-ui-client-types": "static-1.16912",
      "marketplace-ui-common": "static-1.19505",
      "ui-addon-integrations-directory-panel": "static-2.7943",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.121",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15041",
      "simple-menus-lib": "static-1.16558",
      "academy-common-lib": "static-1.13604",
      "dashboard-lib": "static-1.81309",
      "share-with-third-party-component-lib": "static-1.8646",
      "commerce-totals-service-types": "static-1.3775",
      "campaign-roi-lib": "static-1.8916",
      "apps-service-types": "static-1.3826",
      "oauth-service-types": "static-1.4198",
      "academy-service-client": "static-1.3631",
      "croppie": "static-2.10",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28965",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9623",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4665",
      "atom": "/atom/static-1.5020",
      "conversations-async-data": "/conversations-async-data/static-2.7613",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8831",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15922",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12789",
      "conversations-message-history": "/conversations-message-history/static-1.12511",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10451",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.22328",
      "head-dlb": "/head-dlb/static-1.4938",
      "hs-promise-utils": "/hs-promise-utils/static-1.5542",
      "hs-test-utils": "/hs-test-utils/static-1.7964",
      "hubspot-dlb": "/hubspot-dlb/static-2.1832",
      "HubStyleTokens": "/HubStyleTokens/static-2.11409",
      "I18n": "/I18n/static-7.1610",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2967",
      "jasmine-runner": "/jasmine-runner/static-1.6418",
      "quartz": "/quartz/static-1.6952",
      "react-dlb": "/react-dlb/static-1.77",
      "react-select-plus": "/react-select-plus/static-1.104",
      "react-transition-group": "/react-transition-group/static-2.64",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4421",
      "StyleGuideUI": "/StyleGuideUI/static-3.486",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4480",
      "usage-tracker": "/usage-tracker/static-1.7287",
      "usage-tracker-core": "/usage-tracker-core/static-1.7137",
      "usage-tracker-public": "/usage-tracker-public/static-1.7098",
      "viral-links-lib": "/viral-links-lib/static-1.7001",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6087",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4757",
      "conversations-prop-types": "/conversations-prop-types/static-1.7400",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.21065",
      "cssUtils": "/cssUtils/static-1.778",
      "enviro": "/enviro/static-4.428",
      "flux-actions": "/flux-actions/static-1.330",
      "foundations-components": "/foundations-components/static-1.7826",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6169",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
      "immutable": "/immutable/static-2.77",
      "metrics-js": "/metrics-js/static-1.9542",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.388",
      "raven": "/raven/static-3.5829",
      "react": "/react/static-7.184",
      "react-aria": "/react-aria/static-1.65",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.70",
      "react-rhumb": "/react-rhumb/static-1-feature-id-1324-marker-timings.12",
      "react-utils": "/react-utils/static-2.5300",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8092",
      "signup-constants": "/signup-constants/static-1.18740",
      "styled-components": "/styled-components/static-2.88",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5701",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5898",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
      "raven-hubspot": "/raven-hubspot/static-1.6136",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3359",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.81",
      "quartz-config": "/quartz-config/static-1.730",
      "quartz-core": "/quartz-core/static-1.6171",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4805",
      "foundations-theming": "/foundations-theming/static-1.4365",
      "UIComponents": "/UIComponents/static-3.8356",
      "customer-data-email": "/customer-data-email/static-1.17937",
      "cv-backend-services": "/cv-backend-services/static-1.1551",
      "immutable-less": "/immutable-less/static-1.4598",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7197",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33010",
      "customer-data-objects": "/customer-data-objects/static-1.7610",
      "icons": "/icons/static-2.643",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4598",
      "ui-images": "/ui-images/static-2.1138",
      "HeadJS": "/HeadJS/static-2.740",
      "framer-motion": "/framer-motion/static-1.71",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3075",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.151",
      "i18n-data": "/i18n-data/static-1.220",
      "moment-timezone": "/moment-timezone/static-5.82",
      "jasmine": "/jasmine/static-4.4273",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7987",
      "HubStyle": "/HubStyle/static-2.11717",
      "quartz-i18n": "/quartz-i18n/static-1.627",
      "sassPrefix": "/sassPrefix/static-1.155",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4095",
      "floating-ui": "/floating-ui/static-1.55",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2081",
      "hs-story-utils": "/hs-story-utils/static-1.9377",
      "react-create-root-preference": "/react-create-root-preference/static-1.9",
      "react-virtualized": "/react-virtualized/static-2.98",
      "tanstack-table": "/tanstack-table/static-1.54",
      "trellis-assets": "/trellis-assets/static-1.1656",
      "ui-fonts": "/ui-fonts/static-1.671",
      "hs-locale-management": "/hs-locale-management/static-1.40",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.617",
      "quick-fetch": "/quick-fetch/static-1.3873",
      "web-vitals": "/web-vitals/static-1.4",
      "quartz-routing": "/quartz-routing/static-1.382",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5704",
      "bender-build-tools": "/bender-build-tools/static-1.3123",
      "dispatcher": "/dispatcher/static-1.135",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.826",
      "hubspotter-http": "/hubspotter-http/static-1.4608",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
      "module-federation": "/module-federation/static-1.22",
      "quartz-auth": "/quartz-auth/static-1.627",
      "quartz-test": "/quartz-test/static-1.627",
      "quartz-tracking": "/quartz-tracking/static-1.331",
      "usage-tracker-container": "/usage-tracker-container/static-1.7277",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2848",
      "foundations-theming-base": "/foundations-theming-base/static-1.3350",
      "stylex": "/stylex/static-1.32",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4597",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9775",
      "FileManagerCore": "/FileManagerCore/static-1.38958",
      "FileManagerLib": "/FileManagerLib/static-1.39099",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4825",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.524",
      "timezone-utils": "/timezone-utils/static-2.5192",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10296",
      "ts-schema": "/ts-schema/static-1.4034",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8793",
      "avatar-components": "/avatar-components/static-1.2446",
      "content-assistance-lib": "/content-assistance-lib/static-1.7669",
      "crm-component-utils": "/crm-component-utils/static-1.38929",
      "crm-display-components": "/crm-display-components/static-1.24679",
      "crm-fe-perf": "/crm-fe-perf/static-1.22852",
      "crm-links": "/crm-links/static-1.6230",
      "crm-message-bus": "/crm-message-bus/static-1.42835",
      "crm-search-service-types": "/crm-search-service-types/static-1.1101",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5286",
      "customer-data-communicator": "/customer-data-communicator/static-1.45372",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39558",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12973",
      "customer-data-properties": "/customer-data-properties/static-1.51354",
      "customer-data-rte": "/customer-data-rte/static-1.32848",
      "draft-plugins": "/draft-plugins/static-2.21574",
      "file-manager-components": "/file-manager-components/static-1.23459",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6827",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7876",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18077",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10502",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.473",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8043",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17910",
      "universal-associations-select": "/universal-associations-select/static-1.10971",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.716",
      "wootric-nps": "/wootric-nps/static-1.6932",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3797",
      "property-translator": "/property-translator/static-1.5351",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.8",
      "chirp-fetch": "/chirp-fetch/static-1.1834",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9836",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9834",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4973",
      "react-dnd-compat": "/react-dnd-compat/static-1.4568",
      "audio-components": "/audio-components/static-1.5834",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29197",
      "FileManagerImages": "/FileManagerImages/static-1.36610",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.851",
      "immerable": "/immerable/static-1.4102",
      "ui-universal-auth": "/ui-universal-auth/static-1.8910",
      "video-components": "/video-components/static-1.13092",
      "video-data-lib": "/video-data-lib/static-1.34747",
      "video-embed": "/video-embed/static-1.35581",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.284",
      "chatspot-core": "/chatspot-core/static-1.21022",
      "ContentUtils": "/ContentUtils/static-1.68199",
      "copilot-toolkit": "/copilot-toolkit/static-1.10969",
      "superstore": "/superstore/static-1.4715",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8647",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28389",
      "card-properties-lib": "/card-properties-lib/static-1.44007",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36939",
      "crm-actions": "/crm-actions/static-1.6267",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43415",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9163",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8032",
      "customer-data-tracking": "/customer-data-tracking/static-1.6834",
      "hs-resources": "/hs-resources/static-1.93",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3547",
      "pulse": "/pulse/static-1.504",
      "framework-data-table": "/framework-data-table/static-2.11792",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9078",
      "calling-error-reporting": "/calling-error-reporting/static-1.31255",
      "calling-internal-common": "/calling-internal-common/static-1.31249",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6490",
      "crm_data": "/crm_data/static-4.91777",
      "customer-data-content": "/customer-data-content/static-1.27174",
      "draft-content-plugins": "/draft-content-plugins/static-1.28116",
      "draft-convert": "/draft-convert/static-2.72",
      "draft-extend": "/draft-extend/static-3.74",
      "draft-js": "/draft-js/static-5.77",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23919",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24254",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18069",
      "integration-settings-components": "/integration-settings-components/static-1.15309",
      "integrations-lib": "/integrations-lib/static-1.15941",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5547",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7732",
      "nav-meta": "/nav-meta/static-1.29475",
      "onboarding-scopes": "/onboarding-scopes/static-1.6411",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6102",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.11460",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37881",
      "react-colorpicker": "/react-colorpicker/static-2.10159",
      "reference-resolvers": "/reference-resolvers/static-1.8118",
      "rich-text-lib": "/rich-text-lib/static-1.19735",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3792",
      "sequences-lib": "/sequences-lib/static-1.7945",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11099",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9001",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8996",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10097",
      "user-context": "/user-context/static-1.5050",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5476",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21993",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13107",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4668",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3966",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6732",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.928",
      "onboarding-tours": "/onboarding-tours/static-1.16495",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13507",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21476",
      "calling-global-api": "/calling-global-api/static-1.64315",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65697",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57991",
      "commerce-products-lib": "/commerce-products-lib/static-1.9321",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3753",
      "external-options-client-types": "/external-options-client-types/static-1.4115",
      "google-libphonenumber": "/google-libphonenumber/static-1.37",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4180",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.579",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3648",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48550",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3922",
      "property-value-citations": "/property-value-citations/static-1.1968",
      "smart-property-lib": "/smart-property-lib/static-1.6665",
      "tiered-pricing": "/tiered-pricing/static-1.1094",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10937",
      "video-components-external": "/video-components-external/static-1.11089",
      "batch-promise": "/batch-promise/static-1.1499",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4099",
      "persist-promise": "/persist-promise/static-1.3656",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25204",
      "knowledge-content-types": "/knowledge-content-types/static-1.8479",
      "payment-link-components": "/payment-link-components/static-1.23374",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9836",
      "call-summary": "/call-summary/static-1.39005",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9982",
      "laboratory-lib": "/laboratory-lib/static-3.7107",
      "merchandise-lib": "/merchandise-lib/static-1.262",
      "purchase-motions-components": "/purchase-motions-components/static-1.5786",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9450",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.705",
      "content-icons-ui": "/content-icons-ui/static-1.2211",
      "social-insights-client-types": "/social-insights-client-types/static-1.21929",
      "outpost": "/outpost/static-1.4138",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4759",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5526",
      "magpie-types": "/magpie-types/static-1.4986",
      "simple-logging-lib": "/simple-logging-lib/static-1.2997",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6532",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45842",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15783",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18904",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18364",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10224",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.7",
      "directed-graph": "/directed-graph/static-1.884",
      "event-emitter": "/event-emitter/static-1.897",
      "fast-json-patch": "/fast-json-patch/static-1.62",
      "customer-data-associations": "/customer-data-associations/static-1.7274",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1816",
      "reporting-data": "/reporting-data/static-1.67282",
      "tanstack-virtual": "/tanstack-virtual/static-1.29",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4718",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3567",
      "self-service-api": "/self-service-api/static-1.10194",
      "crm_universal": "/crm_universal/static-1.21911",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9162",
      "content-embed-lib": "/content-embed-lib/static-1.7288",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12152",
      "remote-ui": "/remote-ui/static-1.64",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5547",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16856",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2961",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13356",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10320",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.424",
      "messaging-types-lib": "/messaging-types-lib/static-1.45836",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8005",
      "copilot-plugins": "/copilot-plugins/static-1.10942",
      "data-token-picker": "/data-token-picker/static-1.16308",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7802",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5309",
      "navigation-messaging": "/navigation-messaging/static-1.7165",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18340",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17458",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.561",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.961",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8635",
      "growth-data-modal": "/growth-data-modal/static-1.5342",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3016",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1752",
      "navigation-components": "/navigation-components/static-1.17838",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4709",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7478",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10986",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.758",
      "commerce-permissions": "/commerce-permissions/static-1.714",
      "products-iframe-lib": "/products-iframe-lib/static-1.7766",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10218",
      "data-agent-kit": "/data-agent-kit/static-1.108",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9919",
      "fsm": "/fsm/static-1.3681",
      "policy-lib": "/policy-lib/static-1.6721",
      "react-tinymce": "/react-tinymce/static-1.55084",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54210",
      "tinymce-plugins": "/tinymce-plugins/static-1.57324",
      "tinymce-themes": "/tinymce-themes/static-1.56180",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12063",
      "content-media-compositions": "/content-media-compositions/static-2.16070",
      "idb-keyval": "/idb-keyval/static-1.43",
      "media-bridge-lib": "/media-bridge-lib/static-1.18831",
      "ui-addon-opt": "/ui-addon-opt/static-4.8322",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5993",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5030",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3588",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19226",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8549",
      "purchase-motions-api": "/purchase-motions-api/static-1.5789",
      "trials-service-types": "/trials-service-types/static-1.3852",
      "reactive-lib": "/reactive-lib/static-1.670",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37006",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39362",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11833",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54526",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21304",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17605",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71791",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8606",
      "utility-belt": "/utility-belt/static-1.2486",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22515",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7405",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5615",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14645",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5058",
      "qrcode-generator": "/qrcode-generator/static-1.68",
      "deal-intel-utils": "/deal-intel-utils/static-1.1820",
      "storybook-react": "/storybook-react/static-1.32",
      "reporting-client-types": "/reporting-client-types/static-1.2463",
      "react-flip-move": "/react-flip-move/static-1.69",
      "FireAlarmUi": "/FireAlarmUi/static-1.4470",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4124",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10952",
      "association-settings-lib": "/association-settings-lib/static-1.10125",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57628",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12336",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12415",
      "final-form": "/final-form/static-1.69",
      "html-to-image": "/html-to-image/static-1.53",
      "nudge-client-utils": "/nudge-client-utils/static-1.2439",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7036",
      "property-management-iframe": "/property-management-iframe/static-1.12974",
      "property-usages-lib": "/property-usages-lib/static-1.5372",
      "reactflow": "/reactflow/static-1.63",
      "simple-data-table": "/simple-data-table/static-1.2616",
      "used-in-list-lib": "/used-in-list-lib/static-1.6891",
      "visual-association": "/visual-association/static-1.5819",
      "highcharts": "/highcharts/static-8.103",
      "reporting-visualizations": "/reporting-visualizations/static-1.59358",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3878",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.73",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.185",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2565",
      "ContentData": "/ContentData/static-1.68274",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.925",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1883",
      "ai-rendering-library": "/ai-rendering-library/static-1.9897",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7798",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14990",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.410",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.580",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.352",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6800",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3930",
      "ui-tool-access": "/ui-tool-access/static-1.10098",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1871",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1780",
      "user-context-client": "/user-context-client/static-1.4558",
      "nest": "/nest/static-1.174",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35535",
      "sales-views-client-types": "/sales-views-client-types/static-1.4213",
      "trellis-story-utils": "/trellis-story-utils/static-1.4464",
      "hub-http-contrib": "/hub-http-contrib/static-1.2989",
      "interframe": "/interframe/static-3.4710",
      "tinymce-data": "/tinymce-data/static-1.40295",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5159",
      "codemirror": "/codemirror/static-5.94",
      "layout-dnd-components": "/layout-dnd-components/static-1.12337",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11312",
      "react-codemirror": "/react-codemirror/static-1.10572",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9019",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.39840",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80512",
      "zustand": "/zustand/static-1.72",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6973",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54542",
      "commerce-products-api": "/commerce-products-api/static-1.2207",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56600",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102469",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7628",
      "reporting-ui-components": "/reporting-ui-components/static-2.64553",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14836",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18038",
      "stripe-connect-js": "/stripe-connect-js/static-1.67",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9494",
      "nested-table": "/nested-table/static-1.174",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21013",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2425",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5825",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4203",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2196",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2515",
      "whisper-core-api": "/whisper-core-api/static-1.6447",
      "property-management-common": "/property-management-common/static-1.5262",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15042",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11996",
      "ExportDialog": "/ExportDialog/static-6.10342",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33893",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.14144",
      "highlight.js": "/highlight.js/static-1.78",
      "reporting-action-components": "/reporting-action-components/static-1.41149",
      "reporting-snowflake": "/reporting-snowflake/static-1.55900",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9637",
      "browser-eslint": "/browser-eslint/static-2.57",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.471",
      "property-description-translator": "/property-description-translator/static-1.3796",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3576",
      "totals-ui-components": "/totals-ui-components/static-1.23425",
      "reporting-plugins": "/reporting-plugins/static-1.10202",
      "reporting-reports": "/reporting-reports/static-1.66960",
      "edison-service-client-types": "/edison-service-client-types/static-1.335",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10457",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16912",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19505",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7943",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.121",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15041",
      "simple-menus-lib": "/simple-menus-lib/static-1.16558",
      "academy-common-lib": "/academy-common-lib/static-1.13604",
      "dashboard-lib": "/dashboard-lib/static-1.81309",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8646",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3775",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8916",
      "apps-service-types": "/apps-service-types/static-1.3826",
      "oauth-service-types": "/oauth-service-types/static-1.4198",
      "academy-service-client": "/academy-service-client/static-1.3631",
      "croppie": "/croppie/static-2.10",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.28965",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};